/**
 * Custom html5 video controls
 * Based upon: https://developer.mozilla.org/en-US/docs/Web/Guide/Audio_and_video_delivery/cross_browser_video_player#working_example
 * Styling: https://developer.mozilla.org/en-US/docs/Web/Guide/Audio_and_video_delivery/Video_player_styling_basics
 */
export default (() => {
	let _$controls;
	let _$container;
	let _container;
	let _$video;
	let _video;
	let _progress;
	let _$progressBar;

	const initPlayPause = playPause => {
		$(playPause).attr('data-state', _video.paused ? 'play' : 'pause');
	};

	const handlePlayPause = e => {
		if (_video.paused || _video.ended) {
			_video.play();
			$(e.currentTarget).attr('data-state', 'play');
		} else {
			_video.pause();
			$(e.currentTarget).attr('data-state', 'pause');
		}
	};

	const handleStop = () => {
		_video.pause();
		_video.currentTime = 0;
		_progress.value = 0;
	};

	const initMute = mute => {
		$(mute).attr('data-state', _video.muted ? 'unmute' : 'mute');
	};

	const handleMute = e => {
		_video.muted = !_video.muted;
		$(e.currentTarget).attr('data-state', _video.muted ? 'unmute' : 'mute');
	};

	const alterVolume = dir => {
		const currentVolume = Math.floor(_video.volume * 10) / 10;

		if (dir === '+') {
			if (currentVolume < 1) {
				_video.volume += 0.1;
			}
		} else if (dir === '-') {
			if (currentVolume > 0) {
				_video.volume -= 0.1;
			}
		}
	};

	const videoLoaded = () => {
		$(_progress).attr('max', _video.duration);
	};

	const videoTimeUpdate = () => {
		if (!$(_progress).attr('max')) {
			$(_progress).attr('max', _video.duration);
		}
		_progress.value = _video.currentTime;
		_$progressBar.width(`${Math.floor((_video.currentTime / _video.duration) * 100)}%`);
	};

	const isFullScreen = () => {
		return Boolean(document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
	};

	const setFullscreenData = state => {
		_$container.attr('data-fullscreen', Boolean(state));
	};

	const initFullScreen = fs => {
		const fullScreenEnabled = Boolean(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.createElement('video').webkitRequestFullScreen);
		if (!fullScreenEnabled) {
			$(fs).hide();
		}

		$(document).on('fullscreenchange', () => {
			setFullscreenData(Boolean(document.fullscreen || document.fullscreenElement));
		});

		$(document).on('webkitfullscreenchange', () => {
			setFullscreenData(Boolean(document.webkitIsFullScreen));
		});

		$(document).on('mozfullscreenchange', () => {
			setFullscreenData(Boolean(document.mozFullScreen));
		});

		$(document).on('msfullscreenchange', () => {
			setFullscreenData(Boolean(document.msFullscreenElement));
		});
	};

	const handleFullScreen = () => {
		if (isFullScreen()) {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
			setFullscreenData(false);
		} else {
			if (_container.requestFullscreen) {
				_container.requestFullscreen();
			} else if (_container.mozRequestFullScreen) {
				_container.mozRequestFullScreen();
			} else if (_container.webkitRequestFullScreen) {
				_container.webkitRequestFullScreen();
			} else if (_container.msRequestFullscreen) {
				_container.msRequestFullscreen();
			}
			setFullscreenData(true);
		}
	};

	const handleProgress = e => {
		const rect = e.currentTarget.getBoundingClientRect();
		const pos  = (e.pageX  - rect.left) / e.currentTarget.offsetWidth;
		_video.currentTime = pos * _video.duration;
	};

	const initVideoControls = () => {
		const playPause   = _$controls.find('#playpause');
		const stop        = _$controls.find('#stop');
		const mute        = _$controls.find('#mute');
		const voldec      = _$controls.find('#voldec');
		const volinc      = _$controls.find('#volinc');
		const fullScreen  = _$controls.find('#fs');
		const progress    = _$controls.find('#progress');
		_$progressBar     = _$controls.find('#progress-bar');
		_progress         = progress.get(0);

		initPlayPause(playPause);
		initMute(mute);
		initFullScreen(fullScreen);

		_$video.on('loadedmetadata', videoLoaded);
		_$video.on('timeupdate', videoTimeUpdate);
		playPause.on('click', handlePlayPause);
		stop.on('click', handleStop);
		mute.on('click', handleMute);
		voldec.on('click', alterVolume('-'));
		volinc.on('click', alterVolume('+'));
		fullScreen.on('click', handleFullScreen);
		progress.on('click', handleProgress);
	};

	const init = controls => {
		_$controls  = controls;
		_$container = $(controls).parent();
		_$video     = _$container.find('video');
		_container  = _$container.get(0);
		_video      = _$video.get(0);

		const supportsVideo = Boolean(document.createElement('video').canPlayType);
		if (supportsVideo && _$video.length && _$controls.length) {
			initVideoControls();
		}
	};

	return {
		init
	};
})();